import "./../App.css"
import React from "react"

import Header from "../components/Header"

import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"

import { Outlet, Link } from "react-router-dom"

const tab_items = [
	{ name: "Entrenos", url: "entrenos" },
	{ name: "¿Qué necesito?", url: "needs" },
	{ name: "Generar partidos", url: "new_game" },
]

class TrainingsPage extends React.Component {
	constructor() {
		super()
		this.state = {
			tab_value: 0,
		}
	}

	handleChange = (event, newValue) => {
		this.setState({ tab_value: newValue })
	}
	render() {
		return (
			<div className="content">
				<Header title="Entrenamientos" />
				<br></br>
				<Tabs
					// disable the tab indicator because it doesn't work well with wrapped container
					TabIndicatorProps={{ sx: { display: "none" } }}
					sx={{
						"& .MuiTabs-flexContainer": {
							flexWrap: "wrap",
						},
					}}
					value={this.state.tab_value}
					onChange={this.handleChange}
					centered
				>
					{tab_items.map((tab, i) => (
						<Tab
							key={"tab_" + i}
							label={tab.name}
							component={Link}
							to={tab.url}
						/>
					))}
				</Tabs>
				<br></br>

				<Outlet />
			</div>
		)
	}
}
export default TrainingsPage
